export const availablePages = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'customers', label: 'Customers' },
  { key: 'products', label: 'Products' },
  { key: 'quotes', label: 'Quotes' },
  { key: 'subscriptions', label: 'Sales' },
  { key: 'invoices', label: 'Invoices' },
  { key: 'feedback', label: 'Follow-ups' },
  { key: 'settings', label: 'Settings' },
  { key: 'logs', label: 'System Logs' }
];

export const actionKeys = ['view', 'create', 'edit', 'delete'];
export const tableActionKeys = ['view', 'edit', 'delete', 'followup', 'renewal', 'payment', 'export', 'upload'];

export const specialPermissions = [
  { key: 'uploadFiles', label: 'Upload Files' },
  { key: 'exportFiles', label: 'Export Files' },
  { key: 'addCustomer', label: 'Add Customer' },
  { key: 'editCustomer', label: 'Edit Customer' },
  { key: 'deleteCustomer', label: 'Delete Customer' },
  { key: 'addProduct', label: 'Add Product' },
  { key: 'editProduct', label: 'Edit Product' },
  { key: 'deleteProduct', label: 'Delete Product' },
  { key: 'addSales', label: 'Add Sales' },
  { key: 'editSales', label: 'Edit Sales' },
  { key: 'deleteSales', label: 'Delete Sales' },
  { key: 'addPayment', label: 'Add Payment' },
  { key: 'editPayment', label: 'Edit Payment' },
  { key: 'deletePayment', label: 'Delete Payment' },
  { key: 'addQuote', label: 'Add Quote' },
  { key: 'editQuote', label: 'Edit Quote' },
  { key: 'deleteQuote', label: 'Delete Quote' }
];

export const buildActionPermissions = (readOnly = false, existing = {}) =>
  availablePages.reduce((acc, page) => {
    acc[page.key] = {
      view: existing?.[page.key]?.view ?? true,
      create: readOnly ? false : (existing?.[page.key]?.create ?? true),
      edit: readOnly ? false : (existing?.[page.key]?.edit ?? true),
      delete: readOnly ? false : (existing?.[page.key]?.delete ?? true)
    };
    return acc;
  }, {});

export const buildCustomPermissions = (readOnly = false, existing = {}) =>
  specialPermissions.reduce((acc, permission) => {
    acc[permission.key] = readOnly ? false : (existing?.[permission.key] ?? true);
    return acc;
  }, {});

export const buildTableActions = (readOnly = false, existing = {}) =>
  availablePages.reduce((acc, page) => {
    acc[page.key] = tableActionKeys.reduce((featureAcc, action) => {
      featureAcc[action] = readOnly && action !== 'view' ? false : (existing?.[page.key]?.[action] ?? true);
      return featureAcc;
    }, {});
    return acc;
  }, {});
